import { render, staticRenderFns } from "./moduleEdit.vue?vue&type=template&id=f109fa8e&scoped=true&"
import script from "./moduleEdit.vue?vue&type=script&lang=js&"
export * from "./moduleEdit.vue?vue&type=script&lang=js&"
import style0 from "./moduleEdit.vue?vue&type=style&index=0&id=f109fa8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f109fa8e",
  null
  
)

export default component.exports